import PropTypes from "prop-types";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Breadcrumb from "app/pages/Breadcrumb/Breadcrumb.jsx";
import BreadcrumbItem from "app/pages/Breadcrumb/BreadcrumbItem.jsx";
import "./booking-header.scss";
import { matchPath, useLocation } from "react-router-dom";
import { isServerSide } from "app/utils/utils";
import useHidePartnerCustomHeader from "app/utils/hooks/useHidePartnerCustomHeader";
import HeaderContainer from "app/pages/Header/HeaderContainer";
import PriceChangedWarningMessage from "app/pages/Booking/Payment/PriceChangedWarningMessage";
import { bookingPropTypes, quotationPropTypes } from "app/utils/propTypes";
import { TRANSPORTATION_TYPES, RESOLUTION } from "app/constants";

const BookingHeader = ({
	resolution,
	ficheProduitUri,
	booking = {},
	quotation = {},
	priceChangeData = {},
}) => {
	const location = useLocation();

	useHidePartnerCustomHeader({ hide: true });

	useEffect(() => {
		// hide header for SP
		if (!isServerSide && window.popupBridge && window.popupBridge.open) {
			const bookingHeader = document.getElementsByClassName("simple-header")[0];

			if (bookingHeader) {
				bookingHeader.style.display = "none";
			}
		}
	}, [location.pathname]);

	const currentPathname = location.pathname;
	const isBookingAuthPage = matchPath({ path: "/booking/auth" }, currentPathname);
	const isBookingSearchPage = matchPath({ path: "/booking/search" }, currentPathname);

	const isFirstStep =
		matchPath(
			{
				path: `/${ficheProduitUri}`,
			},
			currentPathname
		) ||
		matchPath(
			{
				path: "/booking/search",
			},
			currentPathname
		);

	const isSearchPage = matchPath(
		{
			path: "/booking/search",
		},
		currentPathname
	);

	const isQuotationPage = matchPath(
		{
			path: "/booking/quote",
		},
		currentPathname
	);

	const isPaiementPage = matchPath(
		{
			path: "/booking/payment",
		},
		currentPathname
	);

	const isConfirmationPage = matchPath(
		{
			path: "/booking/confirmation",
		},
		currentPathname
	);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	return (
		<div>
			<header className="booking-header" data-testid="booking-header">
				<HeaderContainer
					showMenuItems={false}
					showDialPhone={true}
					showBackBtn={true}
					disabledHomeRedirect={isSearchPage || isQuotationPage || isPaiementPage}
				/>
				<div className="booking-header__breadcrumb">
					<Breadcrumb>
						<BreadcrumbItem
							isActive={Boolean(isFirstStep)}
							isPassed={
								Boolean(isPaiementPage) ||
								Boolean(isQuotationPage) ||
								isBookingAuthPage ||
								Boolean(isConfirmationPage)
							}
							label={<FormattedMessage id="booking.breadcrumb.step.1" />}
							disableClick={true}
						/>
						<BreadcrumbItem
							isActive={Boolean(isQuotationPage)}
							isDisabled={Boolean(isFirstStep)}
							isPassed={
								Boolean(isPaiementPage) ||
								isBookingAuthPage ||
								Boolean(isConfirmationPage)
							}
							label={<FormattedMessage id="booking.breadcrumb.step.2" />}
							disableClick={true}
						/>
						<BreadcrumbItem
							isActive={Boolean(isPaiementPage)}
							isDisabled={Boolean(isFirstStep) || Boolean(isQuotationPage)}
							isPassed={Boolean(isConfirmationPage)}
							label={<FormattedMessage id="booking.breadcrumb.step.3" />}
							disableClick={true}
						/>
						<BreadcrumbItem
							isActive={Boolean(isConfirmationPage)}
							isDisabled={
								Boolean(isFirstStep) ||
								Boolean(isQuotationPage) ||
								Boolean(isPaiementPage)
							}
							label={<FormattedMessage id="booking.breadcrumb.step.4" />}
							disableClick={true}
						/>
					</Breadcrumb>
				</div>
				{isMobile &&
					priceChangeData?.isPriceChange &&
					!isBookingAuthPage &&
					!isBookingSearchPage && (
						<PriceChangedWarningMessage
							offerType={booking?.offer?.type}
							newPrice={quotation?.priceChange?.newPrice}
							oldPrice={quotation?.priceChange?.oldPrice}
							isTravelingByTrain={
								booking?.flight?.type === TRANSPORTATION_TYPES.TRAIN
							}
							{...isQuotationPage && {
								messageFlightAccommodationChangeUp:
									"error.quotation.price.changed.up.message",
								messageFlightAccommodationChangeDown:
									"error.quotation.price.changed.down.message",
								messageAccommodationOnlyChangeUp:
									"error.quotation.price.changed.up.message",
								messageAccommodationOnlyChangeDown:
									"error.quotation.price.changed.down.message",
							}}
						/>
					)}
			</header>
		</div>
	);
};

BookingHeader.propTypes = {
	resolution: PropTypes.string,
	ficheProduitUri: PropTypes.string,
	quotation: quotationPropTypes,
	booking: bookingPropTypes,
	priceChangeData: PropTypes.object,
};

export default BookingHeader;
